import { BubblehousePointsRounding } from "@redotech/congo-enums/bubblehouse-points-rounding";
import * as z from "zod";

export const updateBubblehouseIntegration = {
  name: "updateBubblehouseIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    sharedSecret: z.base64("Shared secret must be base64-encoded").optional(),
    shopSlug: z.string().min(1).optional(),
    keyId: z.string().min(1).optional(),
    pointsPerDollar: z.number().positive().optional(),
    pointsRounding: z.enum(BubblehousePointsRounding).optional(),
  }),
  output: z.object({}),
};
